import { http } from '@/api/http'
import type { StationKey, StationPrinterConfig } from '@/lib/pos-types'
import { normalizeStationPrinter, unwrapList, unwrapSingle } from '@/api/normalizers'

type StationPrinterUpdatePayload = Partial<Pick<StationPrinterConfig, 'enabled' | 'name' | 'ip' | 'port' | 'driver' | 'options'>>

export const stationPrintersApi = {
  list: async (): Promise<StationPrinterConfig[]> => {
    const res = await http.get<unknown>('/stations/printers')
    return unwrapList(res.data).map(normalizeStationPrinter)
  },
  get: async (stationKey: StationKey): Promise<StationPrinterConfig> => {
    const res = await http.get<unknown>(`/stations/${encodeURIComponent(stationKey)}/printer`)
    return normalizeStationPrinter(unwrapSingle(res.data))
  },
  update: async (stationKey: StationKey, payload: StationPrinterUpdatePayload): Promise<StationPrinterConfig> => {
    const res = await http.put<unknown>(`/stations/${encodeURIComponent(stationKey)}/printer`, payload)
    return normalizeStationPrinter(unwrapSingle(res.data))
  },
  testPrint: async (stationKey: StationKey): Promise<{ success: boolean; errno: number; error: string }> => {
    const res = await http.post<unknown>(`/stations/${encodeURIComponent(stationKey)}/printer/test-print`, {})
    const data = unwrapSingle(res.data) as { queued?: boolean; errno?: number; error?: string }
    return { success: Boolean(data?.queued), errno: Number(data?.errno ?? 0), error: String(data?.error ?? '') }
  },
}
